module.exports = __webpack_public_path__ + "img/public/AdminIcons/languageIcon.svg?21009771";